import {injectable} from 'inversify'
import {NotificationsClient} from 'dna-notification-client'
import {action, makeObservable, observable, runInAction} from 'mobx'
import {PLATFORM, SECTION_ROUTES} from '@/stores/notification/constants'
import {INotificationStore} from '@/layouts'
import {NotificationArgsType} from '@/stores/notification/types'
import {storage} from '@/services/storage'
import {ACCESS_TOKEN_KEY} from '@/constants/auth-constants'
import {syncWebSocketNotifications} from '@/stores/notification/services/syncWebSocketNotifications'
import {isNotificationEnabled} from '@/constants/notification'

@injectable()
export class AuthNotificationStore implements INotificationStore {
    notificationClient: NotificationsClient | null = null
    sections = {}
    isAppBlocked = false
    accessToken: string = storage.get(ACCESS_TOKEN_KEY)

    constructor() {
        makeObservable(this, {
            sections: observable,
            isAppBlocked: observable,
            notificationClient: observable,
            eventHandler: action.bound
        })

        this.startOnLogin()
    }

    public eventHandler(args: NotificationArgsType[]) {
        const newSections = {}

        if (!args.length) {
            runInAction(() => {
                this.sections = {}
                this.isAppBlocked = false
                syncWebSocketNotifications([], 'auth')
            })
            return
        }

        args.forEach((notification) => {
            const {systemId, notificationContentAreaId, descriptionLine1} = notification
            if (systemId === PLATFORM) {
                newSections[notificationContentAreaId] = {
                    description: descriptionLine1,
                    route: SECTION_ROUTES[notificationContentAreaId],
                    ...notification
                }
            }
        })

        syncWebSocketNotifications(args as [], 'auth')
        runInAction(() => (this.sections = newSections))
    }

    startOnLogin = () => {
        if (this.accessToken && isNotificationEnabled) {
            if (this.notificationClient) this.closeConnection()

            this.notificationClient = NotificationsClient.getInstance(_AUTH_NOTIFICATION_URL_, {
                Authorization: `Bearer ${this.accessToken}`,
                systemId: 'mp'
            })

            this.notificationClient.subscribe(this)
        } else {
            this.closeConnection()
        }
    }

    refreshOnTokenChange = (result) => {
        if (result?.access_token && isNotificationEnabled) {
            this.closeConnection()
            this.notificationClient = NotificationsClient.getInstance(_AUTH_NOTIFICATION_URL_, {
                Authorization: `Bearer ${result?.access_token}`,
                systemId: 'mp'
            })
            this.notificationClient.subscribe(this)
        } else {
            this.closeConnection()
        }
    }

    public closeConnection = () => {
        if (this.notificationClient) {
            this.notificationClient.unsubscribe()
            this.notificationClient = null
        }
    }
}
